import axios from '../../utils/axios'
import store from '../store'

// Package Lookup
export const SET_PACKAGE_LOOKUP_LOADER = 'SET_PACKAGE_LOOKUP_LOADER'
export const GET_QA_PACKAGE = 'GET_QA_PACKAGE'
export const GET_QA_PACKAGE_SUCCESS = 'GET_QA_PACKAGE_SUCCESS'
export const GET_QA_PACKAGE_ERROR = 'GET_QA_PACKAGE_ERROR'
// Stuff Station
export const POST_STUFF_STATION_SUCCESS = 'POST_STUFF_STATION_SUCCESS'
export const POST_STUFF_STATION_ERROR = 'POST_STUFF_STATION_ERROR'
// Final Scan Station
export const POST_FINAL_SCAN_STATION_SUCCESS = 'POST_FINAL_SCAN_STATION_SUCCESS'
export const POST_FINAL_SCAN_STATION_ERROR = 'POST_FINAL_SCAN_STATION_ERROR'
// Weight Station
export const POST_WEIGHT_STATION_SUCCESS = 'POST_WEIGHT_STATION_SUCCESS'
export const POST_WEIGHT_STATION_ERROR = 'POST_WEIGHT_STATION_ERROR'
// Calculator
export const SET_CALCULATOR_LOADER = 'SET_CALCULATOR_LOADER'
export const POST_CALCULATOR_RESULTS_SUCCESS = 'POST_CALCULATOR_RESULTS_SUCCESS'
export const POST_CALCULATOR_RESULTS_ERROR = 'POST_CALCULATOR_RESULTS_ERROR'
export const GET_CALCULATOR_VALUES_SUCCESS = 'GET_CALCULATOR_VALUES_SUCCESS'
export const GET_CALCULATOR_VALUES_ERROR = 'GET_CALCULATOR_VALUES_ERROR'
export const SET_FINAL_SCAN_TOTAL_COUNTDOWN = 'SET_FINAL_SCAN_TOTAL_COUNTDOWN'
export const SET_STUFF_TOTAL_COUNTDOWN = 'SET_STUFF_TOTAL_COUNTDOWN'
// Count Down
export const SET_COUNTDOWN_LOADER = 'SET_COUNTDOWN_LOADER'
export const GET_COUNTDOWN_VALUES_SUCCESS = 'GET_COUNTDOWN_VALUES_SUCCESS'
export const GET_COUNTDOWN_ERROR = 'GET_COUNTDOWN_ERROR'

export const GetQaPackage = (id) => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    baseURL: config.baseURL,
    url: '/package/qapackage',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      PackageId: parseInt(id)
    }
  }

  return (dispatch) => {
    dispatch(SetPackageLookupLoader(true))
    return axios(axiosConfig)
      .then((response) => {
        dispatch(SetQaPackage(response.data?.Package))
        dispatch(GetQaPackageSuccess(true))
      })
      .catch((error) => {
        console.log(`GetQaPackage error is: ${error.message}`)
        dispatch(GetQaPackageError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
      .finally(() => {
        dispatch(SetPackageLookupLoader(false))
        setTimeout(() => {
          dispatch(GetQaPackageError(''))
          dispatch(GetQaPackageSuccess(false))
        }, 1000)
      })
  }
}

export const PostCalculatorResults = (results) => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    baseURL: config.baseURL,
    url: '/package/qacalculator',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      CalculatorValues: results
    }
  }

  return (dispatch) => {
    dispatch(SetCalculatorLoader(true))
    return axios(axiosConfig)
      .then(() => {
        dispatch(PostCalculatorSuccess(true))
      })
      .catch((error) => {
        console.log(`PostCalculatorResults error is: ${error.message}`)
        dispatch(PostCalculatorError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
      .finally(() => {
        dispatch(SetCalculatorLoader(false))
        setTimeout(() => {
          dispatch(PostCalculatorError(''))
          dispatch(PostCalculatorSuccess(false))
        }, 800)
      })
  }
}

export const PostQaStuffStationResults = (results) => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    baseURL: config.baseURL,
    url: '/package/stuffstation',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      StuffStationValues: results
    }
  }

  return (dispatch) => {
    dispatch(SetPackageLookupLoader(true))
    return axios(axiosConfig)
      .then(() => {
        dispatch(PostStuffStationSuccess(true))
      })
      .catch((error) => {
        console.log(`PostQaStuffStationResults error is: ${error.message}`)
        dispatch(PostStuffStationError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
      .finally(() => {
        dispatch(SetPackageLookupLoader(false))
        setTimeout(() => {
          dispatch(PostStuffStationError(''))
          dispatch(PostStuffStationSuccess(false))
        }, 800)
      })
  }
}

export const PostQaFinalScanResults = (results) => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    baseURL: config.baseURL,
    url: '/package/qafinalscan',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      QAValues: results
    }
  }

  return (dispatch) => {
    dispatch(SetPackageLookupLoader(true))
    return axios(axiosConfig)
      .then(() => {
        dispatch(PostQaFinalScanSuccess(true))
      })
      .catch((error) => {
        console.log(`PostQaFinalScanResults error is: ${error.message}`)
        dispatch(PostQaFinalScanError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
      .finally(() => {
        dispatch(SetPackageLookupLoader(false))
        setTimeout(() => {
          dispatch(PostQaFinalScanError(''))
          dispatch(PostQaFinalScanSuccess(false))
        }, 800)
      })
  }
}

export const PostQaWeightStationResults = (results) => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    baseURL: config.baseURL,
    url: '/package/qaweightdiscrepancy',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      WeightStationValues: results
    }
  }

  return (dispatch) => {
    dispatch(SetPackageLookupLoader(true))
    return axios(axiosConfig)
      .then(() => {
        dispatch(PostWeightStationSuccess(true))
      })
      .catch((error) => {
        console.log(`PostQaWeightStationResults error is: ${error.message}`)
        dispatch(PostWeightStationError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
      .finally(() => {
        dispatch(SetPackageLookupLoader(false))
        setTimeout(() => {
          dispatch(PostWeightStationError(''))
          dispatch(PostWeightStationSuccess(false))
        }, 800)
      })
  }
}

export const GetCalculatorValues = () => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    baseURL: config.baseURL,
    url: '/package/qacalculatorvalues',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      StartDate: new Date(),
      EndDate: new Date()
    }
  }

  return (dispatch) => {
    dispatch(SetCalculatorLoader(true))
    return axios(axiosConfig)
      .then((result) => {
        dispatch(GetCalculatorValuesSuccess(result.data?.CalculatorValues))
      })
      .catch((error) => {
        console.log(`GetCalculatorValues error is: ${error.message}`)
        dispatch(GetCalculatorValuesError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      }).finally(() => {
        dispatch(SetCalculatorLoader(false))
      })
  }
}

export const GetCountDownValues = () => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'get',
    baseURL: config.baseURL,
    url: '/package/countpagevalues',
    headers: {
      'Content-Type': 'application/json'
    }
  }

  return (dispatch) => {
    dispatch(SetCountDownLoader(true))
    return axios(axiosConfig)
      .then((response) => {
        dispatch(GetCountDownValuesSuccess(response.data.Response))
      })
      .catch(error => {
        console.log(`GetCountDownValues error is: ${error.message}`)
        dispatch(GetCountDownError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
      .finally(() => {
        dispatch(SetCountDownLoader(false))
      })
  }
}

export const SetPackageLookupLoader = (isLoading) => {
  return {
    type: SET_PACKAGE_LOOKUP_LOADER,
    loading: isLoading
  }
}

export const SetQaPackage = (qaPackage) => {
  return {
    type: GET_QA_PACKAGE,
    qaPackage
  }
}

export const GetQaPackageSuccess = (isSuccess) => {
  return {
    type: GET_QA_PACKAGE_SUCCESS,
    lookupSuccess: isSuccess
  }
}

export const GetQaPackageError = (error) => {
  return {
    type: GET_QA_PACKAGE_ERROR,
    error
  }
}

export const PostStuffStationSuccess = (isSuccess) => {
  return {
    type: POST_STUFF_STATION_SUCCESS,
    stationSubmitSuccess: isSuccess
  }
}

export const PostStuffStationError = (error) => {
  return {
    type: POST_STUFF_STATION_ERROR,
    error
  }
}

export const PostQaFinalScanSuccess = (isSuccess) => {
  return {
    type: POST_FINAL_SCAN_STATION_SUCCESS,
    stationSubmitSuccess: isSuccess
  }
}

export const PostQaFinalScanError = (error) => {
  return {
    type: POST_FINAL_SCAN_STATION_ERROR,
    error
  }
}

export const PostWeightStationSuccess = (isSuccess) => {
  return {
    type: POST_WEIGHT_STATION_SUCCESS,
    stationSubmitSuccess: isSuccess
  }
}

export const PostWeightStationError = (error) => {
  return {
    type: POST_WEIGHT_STATION_ERROR,
    error
  }
}

export const SetCalculatorLoader = (isLoading) => {
  return {
    type: SET_CALCULATOR_LOADER,
    loading: isLoading
  }
}

export const PostCalculatorSuccess = (isSuccess) => {
  return {
    type: POST_CALCULATOR_RESULTS_SUCCESS,
    calculatorSuccess: isSuccess
  }
}

export const PostCalculatorError = (error) => {
  return {
    type: POST_CALCULATOR_RESULTS_ERROR,
    error
  }
}

export const GetCalculatorValuesSuccess = (values) => {
  return {
    type: GET_CALCULATOR_VALUES_SUCCESS,
    values
  }
}

export const GetCalculatorValuesError = (error) => {
  return {
    type: GET_CALCULATOR_VALUES_ERROR,
    error
  }
}

export const SetCountDownLoader = (isLoading) => {
  return {
    type: SET_COUNTDOWN_LOADER,
    loading: isLoading
  }
}

export const GetCountDownValuesSuccess = (values) => {
  return {
    type: GET_COUNTDOWN_VALUES_SUCCESS,
    values
  }
}

export const GetCountDownError = (error) => {
  return {
    type: GET_COUNTDOWN_ERROR,
    error
  }
}
